var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6663 7.33439L24.4376 11.1056M17.3333 28.0002H28M4 28.0007L4.06327 27.5579C4.28715 25.9907 4.39909 25.2071 4.65372 24.4755C4.87966 23.8264 5.18833 23.2091 5.57208 22.6388C6.00455 21.9962 6.56425 21.4365 7.68366 20.3171L23.2143 4.78642C24.2557 3.74502 25.9442 3.74502 26.9856 4.78642C28.027 5.82782 28.027 7.51626 26.9856 8.55765L11.1699 24.3733C10.1544 25.3888 9.64663 25.8966 9.06826 26.3004C8.5549 26.6588 8.00124 26.9557 7.41864 27.185C6.76228 27.4434 6.05834 27.5854 4.65057 27.8695L4 28.0007Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c88049a231d82cf34904872b45f59d8e.svg";
export { ForwardRef as ReactComponent };